import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export type InteractionSlice = {
  state: Record<string, boolean>;
  boundarySpec: BoundarySpec | null;
};

const initialState: InteractionSlice = {
  state: {},
  boundarySpec: null,
}


export const interactionSlice = createSlice({
  name: 'interaction',
  initialState,
  reducers: {
    setState(state, action: PayloadAction<Record<string, boolean>>) {
      state.state = {
        ...state.state,
        ...action.payload,
      }
    },
    toggleStates(state, action: PayloadAction<string[]>) {
      const newState = {
        ...state.state,
      }
      for (const toggleStateKey of action.payload) {
        newState[toggleStateKey] = !newState[toggleStateKey];
      }
      state.state = newState;
    },
    setBoundary(state, action: PayloadAction<BoundarySpec | null>) {
      state.boundarySpec = action.payload;
    },
    resetBoundary(state) {
      state.boundarySpec = null;
    },
    resetState(state) {
      state.state = {};
    }
  },
});

export const interactionReducer = interactionSlice.reducer;
export const interactionActions = interactionSlice.actions;

